export default {"src":"/_next/static/media/CapterraSvg.e0132582.svg","height":24,"width":105,"blurWidth":0,"blurHeight":0};